export default "__VITE_ASSET__DdLCQyQi__"